module.exports = __webpack_public_path__ + "static/blm-protests-ede52c011943e8325b9690401b749782.png";